import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureService } from './feature.service';

@Pipe({
	name: 'feature',
	standalone: false,
})
export class FeaturePipe implements PipeTransform {

	constructor(private feature: FeatureService) {}

	transform(feature: string): Observable<boolean> {
		return this.feature.has(feature);
	}

}
